import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_h448y6kg3f: FaireBrandEntity = {
  token: "b_h448y6kg3f",
  type: "brand",
  name: "Smile Boutiques",
  avatarUrl:
    "https://cdn.faire.com/fastly/c53a99b4ac0a5f530110e1668b86989020f118b363d2a01d17506c9f5858fae2.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/84ca51cb3deaf6be2035815d728cca399c6fb5a744b102511349bda5eb6620c6.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c53a99b4ac0a5f530110e1668b86989020f118b363d2a01d17506c9f5858fae2.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/84ca51cb3deaf6be2035815d728cca399c6fb5a744b102511349bda5eb6620c6.jpeg",
  location: "Toronto, ON, CAN",
  minimumOrderDollars: 100,
  rating: 4.8,
  reviewCount: 103,
  isInsider: false,
  description:
    "Our goal is to be a one-stop shop for safe, high quality, ethically-sourced and Earth-friendly alternatives to everyday plastic products,\nOur mission is to operate a responsible business that improves the lives of people and cares for the environment.",
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:14:07.731Z",
    importedBy: "entity-db-cli",
  },
};
